import cx from "classnames";
import castArray from "lodash/castArray";
import get from "lodash/get";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Tooltip } from "react-tooltip";

import formStyles from "@/styles/form.module.scss";

type PartFormErrorProps = {
  name: string | string[];
};

const PartFormError: React.FC<PartFormErrorProps> = props => {
  const { name } = props;
  const {
    formState: { errors },
  } = useFormContext();
  const id = React.useId();
  const names = castArray(name).filter(Boolean);
  let errorMsg;

  for (const name1 of names) {
    errorMsg = get(errors, name1)?.message;
    if (errorMsg) break;
  }
  const divRef1 = React.useRef<HTMLDivElement>(null);
  const divRef2 = React.useRef<HTMLDivElement>(null);
  const [heights, setHeights] = React.useState<number[]>([]);
  React.useEffect(() => {
    if (divRef1.current && divRef2.current) {
      setHeights([divRef1.current.offsetHeight, divRef2.current.offsetHeight]);
      // or divRef.current.getBoundingClientRect().height for fractional values
    }
  }, [errorMsg]);
  const [interactive, setInteractive] = React.useState<boolean>(false);
  React.useEffect(() => {
    setInteractive(heights[0] !== heights[1]);
  }, [heights]);
  return (
    <>
      <Tooltip id={`form-error-${id}`} place="top">
        There are errors in the form
      </Tooltip>
      {errorMsg ? (
        <div
          className={cx(formStyles.formErrorMessageContainer, {
            [formStyles.canExpand]: interactive,
          })}
        >
          <p className={formStyles.formErrorMessage} ref={divRef1}>
            {errorMsg as string}
          </p>
          <p className={formStyles.formErrorMessageFull} ref={divRef2}>
            {errorMsg as string}
          </p>
        </div>
      ) : null}
    </>
  );
};

export default PartFormError;
